export const fontFamily = [
  'var(--font-base)',
  'Roboto-Medium',
  "'Onest'",
  "'Inter'",
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');

export const oneXbetFont =
  "'Onest', -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif";

export const font = {
  fonts: {
    body: fontFamily,
    heading: fontFamily,
  },
  fontSizes: {
    '4xs': '8px',
    '3xs': '10px',
    '2xs': '12px',
    xs: '13px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '32px',
    '5xl': '40px',
  },
  fontWeights: {
    normal: 400,
    regular: 'normal',
    medium: 500,
    semibold: 600,
    bold: 900,
  },
  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    '3': '.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
  },
};
